import React from 'react';
import PurchaseTable from './table/PurchaseTable';

const Purchase = () => {
  return (
    <div className="tw-space-y-6">
      <div>
        <h1 className="tw-text-2xl tw-font-bold tw-text-foreground tw-m-0">Purchases</h1>
      </div>

      <PurchaseTable />
    </div>
  );
};

export default Purchase;
